import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseHighlightModule } from '@fuse/components';
import { FuseWidgetModule } from '../fuse/components/widget/widget.module';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TemplatesComponent } from './templates/templates.component';
import { AddTemplateComponent } from './templates/add-template/add-template.component';
import { AddTemplateComponent as CitationAddTemplate } from './citacion-templates/add-template/add-template.component';
import { AddTemplateComponent as AddTemplateDialog } from './common-template/add-template/add-template.component';
import { AngularMaterialModule } from 'app/angular-material.module';
import { TemplateService } from './services/template.service';
import { SharedModule } from '../common/shared.module';
import { CitacionTemplatesComponent } from './citacion-templates/citacion-templates.component';
import { CommonTemplateComponent } from './common-template/common-template.component';

@NgModule({
    declarations: [ 
        TemplatesComponent,
        AddTemplateComponent,
        CitationAddTemplate,
        AddTemplateDialog,
        CitacionTemplatesComponent,
        CommonTemplateComponent
    ],
    exports: [
        FuseSharedModule,
        FuseHighlightModule,
        FuseWidgetModule
    ],
    imports: [
        CommonModule,
        FuseSharedModule,
        FuseHighlightModule,
        FuseWidgetModule,
        RouterModule,
        AngularMaterialModule,
        SharedModule,
    ],
    providers: [
        TemplateService
    ]
})
export class MaintenanceModule {
}
